import { render, staticRenderFns } from "./CoSoLuuTruList.vue?vue&type=template&id=db81c738&"
import script from "./CoSoLuuTruList.vue?vue&type=script&lang=js&"
export * from "./CoSoLuuTruList.vue?vue&type=script&lang=js&"
import style0 from "./CoSoLuuTruList.vue?vue&type=style&index=0&id=db81c738&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports